module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', {
    staticClass: "loginForm"
  }, [_c('column', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "widget-user-username",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isLocal) ? _c('div', [_c('input', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "button",
      "value": "Fill Temp Data"
    },
    on: {
      "click": function($event) {
        return _vm.fillDefaultAccount()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Register",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Company Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Company Name"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Please choose your organization email address"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Confirm Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmUsername),
      expression: "confirmUsername"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Confirm Email"
    },
    domProps: {
      "value": (_vm.confirmUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmUsername = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone (e.g. +9720503201111)"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Country"
    },
    domProps: {
      "value": (_vm.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.country = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10",
    staticStyle: {
      "text-align": "right",
      "cursor": "pointer"
    }
  }, [_c('a', {
    staticClass: "control-label",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Log in to an existing account")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Create",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.register($event)
      }
    }
  }), _vm._v(" "), (0 > 1) ? _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Create Test",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.registerTest($event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n      ")])]), _vm._v(" "), _c('va-modal')], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.$root.isLoading
    },
    on: {
      "update:active": function($event) {
        return _vm.$set(_vm.$root, "isLoading", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bc383a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VARegister.vue
// module id = 696
// module chunks = 0